export const ALERT_TEMPLATE_FROM_REPLACE_TARGET = ':fromTarget';
export const DEFAULT_ALERT_TEMPLATE = `New Message\nFrom ${ALERT_TEMPLATE_FROM_REPLACE_TARGET}`;
export function generateBizCustomerAlertRefPath({ businessId, customerId }) {
    return `/businesses/${businessId}/customers/${customerId}`;
}
const BIZ_CUSTOMER_ALERT_REF_PATH_REGEX = /\/businesses\/([^/]+)\/customers\/([^/]+)/;
export function decomposeBizCustomerAlertRefPath(referencePath) {
    const match = BIZ_CUSTOMER_ALERT_REF_PATH_REGEX.exec(referencePath);
    if (match) {
        return { businessId: match[1], customerId: match[2] };
    }
    else {
        return undefined;
    }
}
export function generateBizMessageAlertRefPath({ businessId, threadType, threadId, channelId, messageId }) {
    return `/businesses/${businessId}/${threadType}/${threadId}/channels/${channelId}/messages/${messageId}`;
}
const BIZ_MESSAGE_ALERT_REF_PATH_REGEX = /\/businesses\/([^/]+)\/(messages|posts)\/([^/]+)\/channels\/([^/]+)\/messages\/([^/]+)/;
export function decomposeBizMessageAlertRefPath(referencePath) {
    const match = BIZ_MESSAGE_ALERT_REF_PATH_REGEX.exec(referencePath);
    if (match) {
        return {
            businessId: match[1],
            threadType: match[2],
            threadId: match[3],
            channelId: match[4],
            messageId: match[5]
        };
    }
    else {
        return undefined;
    }
}
export function generateConnMessageAlertRefPath({ bizPrefixedId, threadId, channelId, messageId }) {
    return `/connections/${bizPrefixedId}/messages/${threadId}/channels/${channelId}/messages/${messageId}`;
}
const CONN_MESSAGE_ALERT_REF_PATH_REGEX = /\/connections\/([^/]+)\/messages\/([^/]+)\/channels\/([^/]+)\/messages\/([^/]+)/;
export function decomposeConnMessageAlertRefPath(referencePath) {
    const match = CONN_MESSAGE_ALERT_REF_PATH_REGEX.exec(referencePath);
    if (match) {
        return { bizPrefixedId: match[1], threadId: match[2], channelId: match[3], messageId: match[4] };
    }
    else {
        return undefined;
    }
}
//# sourceMappingURL=alerts.js.map